"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { EmailSoundForm, type EmailSoundFormProps } from "@/components/ui/email-sound-form";

export const EMAIL_FILE_LABEL = "Email me this file";
export const EMAIL_FILE_HELPER = "We'll send the link and install steps. Open the email on your computer.";

/**
 * A phone saved the file but cannot put it on the car's USB drive. These are
 * its two ways forward, shown together after a download on a touch device:
 * email the file to a computer, or follow the phone-to-USB-C guide. The
 * detail-page receipt and the row receipt both render this, so they offer the
 * same choices in the same words.
 */
export function PhoneHandoff({
  soundId,
  surface,
  defaultOpen = false,
}: {
  soundId: string;
  surface: EmailSoundFormProps["surface"];
  defaultOpen?: boolean;
}) {
  return (
    <>
      <EmailSoundForm
        soundId={soundId}
        surface={surface}
        label={EMAIL_FILE_LABEL}
        helper={EMAIL_FILE_HELPER}
        emphasis="primary"
        defaultOpen={defaultOpen}
      />
      <Link
        href="/guide/mobile"
        className="tlsr-focus flex min-h-11 w-full items-center justify-between gap-2 border-b border-[color:var(--tls-border-subtle)] py-3 text-sm font-medium"
        style={{ color: "var(--tls-fg-strong)" }}
      >
        I have a USB-C stick
        <ChevronRight className="size-4 shrink-0" aria-hidden="true" />
      </Link>
    </>
  );
}
